import React, { useEffect, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { loadSnapshotById, versionFromLocation } from '../../../app/apis/snapshotApi'
import { LABELS } from '../../constants/staticText'

// MatchMeista wird nicht neu gebaut: die bestehende Matrix-App wird in diesen
// Abschnitt gemountet (Spec Abschnitt 9). Fehlt ein veröffentlichter Snapshot
// (publishFrom in der Zukunft → 404), zeigt der Abschnitt coming soon.
//
// Die App kommt als eigener Chunk (Audit 2026-10-07, S6): statisch importiert
// steckte sie samt react-slick in jeder Messe-Seite — 531 KB Buendel fuer
// Seiten, die den MatchMeista gar nicht zeigen. Geladen wird sie erst, wenn
// der Snapshot da ist; der Chunk liegt neben dem Buendel (webpack.config.js).
const ladeApp = () => import(/* webpackChunkName: "matchmeista" */ '../../../app/App').then(modul => modul.default)
const MatchMeista = ({ mappingId }) => {
    const container = useRef(null)
    const rootRef = useRef(null)
    // Ein Ergebnis-Link mit Version, deren Stand der Server nicht kennt, sagt
    // das — sonst stuende ein leerer Abschnitt da (Spec 2026-10-06, 3.5).
    const [standWeg, setStandWeg] = useState(false)

    useEffect(() => {
        if (!mappingId || !container.current) return undefined
        let active = true

        loadSnapshotById(mappingId).then(data => {
            if (active && !data && null !== versionFromLocation(window.location.hash)) setStandWeg(true)
            if (!active || !data) return null
            return ladeApp().then(App => {
                if (!active || !container.current) return
                rootRef.current = createRoot(container.current)
                rootRef.current.render(<App data={data} />)
            })
        })

        return () => {
            active = false
            const root = rootRef.current
            rootRef.current = null
            if (root) setTimeout(() => root.unmount(), 0)
        }
    }, [mappingId])

    if (!mappingId) return <p className="section-empty">{LABELS.comingSoon}</p>

    return (
        <>
            {standWeg && <p className="section-empty">{LABELS.resultGone}</p>}
            <div className="section-matchmeista" ref={container} />
        </>
    )
}

export default MatchMeista
